export type FeatureWindow = {
  PointerEvent?: unknown
  TouchEvent?: unknown
  ontouchstart?: unknown
  navigator?: { maxTouchPoints?: number }
}

// Missing only in Safari and iOS 11 and 12, which then take the click handlers in header-init
export function hasPointerEvents(win: FeatureWindow = window): boolean {
  return 'PointerEvent' in win
}

// Mirrors Modernizr, including TouchEvent, which Chromium defines even without a touchscreen. _header.scss relies on that class plus what-input for desktop Chrome hover
export function hasTouchEvents(win: FeatureWindow = window): boolean {
  return 'ontouchstart' in win || 'TouchEvent' in win || (win.navigator?.maxTouchPoints ?? 0) > 0
}

// Same class names Modernizr's setClasses used, so _header.scss keeps working unchanged
export function applyFeatureClasses(
  root: Element = document.documentElement,
  win: FeatureWindow = window,
): void {
  root.classList.add(
    hasTouchEvents(win) ? 'touchevents' : 'no-touchevents',
    hasPointerEvents(win) ? 'pointerevents' : 'no-pointerevents',
  )
}
